<div #kpiValueElement class="kpi-value positive">{{ kpiValue }}</div>
